import API from "../api/api";

export const getFaqs = async () => {
    try {
        const response = await API.post("/faqSection/list", {
            sEcho: 1,
            iDisplayStart: 0,
            iDisplayLength: 100,
            sSearch: "",
            iSortCol_0: 0,
            sSortDir_0: "asc",
            aaSorting: [[0, "asc"]],
            bRegex: false,
            bRegex_0: false,
            bSearchable_0: true,
            bSortable_0: true,
            mDataProp_0: 0
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching FAQ data:", error);
        if (error.response) {
             console.error("Backend Error Details:", error.response.data);
             console.error("Backend Status:", error.response.status);
        }
        throw error;
    }
};

